// seguire guida:
// https://fontawesome.com/how-to-use/on-the-web/using-with/vuejs

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

library.add(fas);

// export
export default {
  install(Vue) {
    Vue.component("fa-icon", FontAwesomeIcon);
  }
};
